import { inject, Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import { PolicyService } from '@features/insured/services/policy/policy.service'
import { CoverageService } from '@features/insured/services/coverages/coverage.service'
import { PolicyApiResponse } from '@features/insured/models/policy/policy.model'
import { AircraftLimitApiResponse } from '@features/insured/models/coverages/coverage-api.model'
import {
  avn52eAircraftLimits,
  buildFurtherInsuredLimits,
  FurtherInsuredLimitValues
} from '@features/certificate/utils/further-insured-limits.util'

@Injectable({ providedIn: 'root' })
export class FurtherInsuredLimitsService {
  private readonly policyService = inject(PolicyService)
  private readonly coverageService = inject(CoverageService)

  /** The saved policies of an insured in the given period, one of which its limits are taken from. */
  public loadPolicies(memberId: string, periodId: string): Observable<PolicyApiResponse[]> {
    return this.policyService.getByMemberIdAndPeriodId(memberId, periodId).pipe(
      map(policies => policies.filter(policy => typeof policy.uuid === 'string' && policy.uuid !== ''))
    )
  }

  /** The limits of a policy, from its coverages. */
  public loadLimits(policyId: string): Observable<FurtherInsuredLimitValues> {
    return this.coverageService.getByPolicyId(policyId).pipe(map(coverages => buildFurtherInsuredLimits(coverages)))
  }

  /** The AVN52E limits per aircraft type of a policy, as the insured shows them. */
  public loadAircraftLimits(policyId: string): Observable<AircraftLimitApiResponse[]> {
    return this.coverageService.getByPolicyId(policyId).pipe(map(coverages => avn52eAircraftLimits(coverages)))
  }
}
